module.exports = {
	"id": "dk-admin/signIn",
	"type": "object",
	"properties": {
		"email": {
			"type": "string",
			"format": "email"
		},
		"password": {
			"type": "string",
			"minLength": 1
		}
	},
	"required": [
		"email",
		"password"
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/common/schema/login.json
// module id = 858
// module chunks = 0